var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 6.66683C3.33325 5.93045 3.93021 5.3335 4.66659 5.3335H11.3333C12.0696 5.3335 12.6666 5.93045 12.6666 6.66683V12.6668C12.6666 13.7714 11.7712 14.6668 10.6666 14.6668H5.33325C4.22868 14.6668 3.33325 13.7714 3.33325 12.6668V6.66683ZM5.99992 8.66683C5.99992 8.29864 6.2984 8.00016 6.66659 8.00016C7.03477 8.00016 7.33325 8.29864 7.33325 8.66683V11.3335C7.33325 11.7017 7.03477 12.0002 6.66659 12.0002C6.2984 12.0002 5.99992 11.7017 5.99992 11.3335V8.66683ZM8.66659 8.66683C8.66659 8.29864 8.96506 8.00016 9.33325 8.00016C9.70144 8.00016 9.99992 8.29864 9.99992 8.66683V11.3335C9.99992 11.7017 9.70144 12.0002 9.33325 12.0002C8.96506 12.0002 8.66659 11.7017 8.66659 11.3335V8.66683Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 1.3335C5.93037 1.3335 5.33341 1.93045 5.33341 2.66683H3.33341C2.96522 2.66683 2.66675 2.96531 2.66675 3.3335C2.66675 3.70169 2.96522 4.00016 3.33341 4.00016H12.6667C13.0349 4.00016 13.3334 3.70169 13.3334 3.3335C13.3334 2.96531 13.0349 2.66683 12.6667 2.66683H10.6667C10.6667 1.93045 10.0698 1.3335 9.33341 1.3335H6.66675Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/TrashIcon.35c18585.svg";
export { ForwardRef as ReactComponent };